import React from 'react';
import { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import FillProfileImage from '../../Components/ImagesWithElements/FillProfileImage';
import styled from 'styled-components';
import { Checkbox, CheckboxProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { RadioChangeEvent } from 'antd';
import { Radio } from 'antd';
import { Button } from 'antd';
import usePortalService from '../../services/PortalService';
import ErrorMessage from '../../Components/Errors/ErrorMessage';

const Styles = styled.div`
    .progress {
    position: absolute;
    width: 34%;
    height: 6px;
    left: 0px;
    top: 0px;
    background: #2196F3
}
`

export const FillProfileStudent1 = () => {
    const navigate = useNavigate();

    const {addInformationYourself, profileCommonInformation, error, clearError} = usePortalService();

    const [firstName, setFirstName] = useState('');

    const [jobSearch, setJobSearch] = useState(false)
    const [traineeshipSearch, setTraineeshipSearch] = useState(false)

    const [gender, setGender] = useState(2);
    const [genderDirty, setGenderDirty] = useState(false);
    const [genderError, setGenderError] = useState('Выберите пол');

    const [region, setRegion] = useState('');
    const [regionDirty, setRegionDirty] = useState(false);
    const [regionError, setRegionError] = useState('Введите регион');

    const [city, setCity] = useState('');
    const [cityDirty, setCityDirty] = useState(false);
    const [cityError, setCityError] = useState('Введите название города');

    const jobHandler: CheckboxProps['onChange'] = (e) => {
        setJobSearch(e.target.checked);
    };

    const traineeshipHandler: CheckboxProps['onChange'] = (e) => {
        setTraineeshipSearch(e.target.checked);
    };

    const onGenderChange = (e: RadioChangeEvent) => {
        setGender(e.target.value);
        setGenderDirty(true)
        setGenderError('')
    };

    const regionHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRegion(e.target.value)
        if (e.target.value.length < 2) {
            setRegionError('Некорректное название региона')
        } else {
            setRegionError('')
        }
    }

    const cityHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCity(e.target.value)
        if (e.target.value.length < 2) {
            setCityError('Некорректное название города')
        } else {
            setCityError('')
        }
    }

    const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case 'area':
                setRegionDirty(true)
                break;
            case 'city':
                setCityDirty(true)
                break;
        }
    }

    useEffect(() => {
        profileCommonInformation().then(result => {
            setFirstName(result.profile.firstName);
            setJobSearch(result.profile.isJob);
            setTraineeshipSearch(result.profile.isTraineeship);
            setGender(result.profile.gender);
            if (result.profile.gender === 0 || result.profile.gender === 1) {
                setGenderError('');
            }
            let item = result.profile.region;
            if (item) {
                setRegion(item);
                setRegionError('');
            }
            item = result.profile.city
            if (item) {
                setCity(item);
                setCityError('');
            }
        });
    }, []);

    const handleContinue = async (e: React.FormEvent) => {
        e.preventDefault();
        if (genderError || regionError || cityError) {
            setGenderDirty(true)
            setRegionDirty(true)
            setCityDirty(true)
        } else {
            try {
                clearError();
                const result = await addInformationYourself({
                    isTraineeship: traineeshipSearch,
                    isJob: jobSearch,
                    gender,
                    region,
                    city
                });
                if (result.success) {
                    navigate("/fillProfile2");
                }
            } catch {
                // ошибка уже сохранена в error и отображается ниже
            }
        }
    }

    return (
        <>
            <div className="main-container">
                <section className="auth-sidebar d-none d-md-block">
                    <FillProfileImage firstName={firstName} />
                </section>
                <div className="content" >
                    <div className="auth-content">
                        <p className="step">Шаг 1 из 3</p>
                        <h1 style={{ marginBottom: '32px' }}> Расскажите подробнее о себе </h1>
                        <h2 style={{ marginBottom: '15px' }}> Я ищу </h2>
                        <div className="group-select-elements">
                            <Checkbox checked={traineeshipSearch} onChange={traineeshipHandler}> Стажировку </Checkbox>
                            <Checkbox checked={jobSearch} onChange={jobHandler}> Работу </Checkbox>
                        </div>
                        <h2 style={{ marginBottom: '15px' }}> Пол </h2>
                        <div className="group-select-elements" >
                            <Radio.Group onChange={onGenderChange} value={gender}>
                                <Radio value={0}>Мужской</Radio>
                                <Radio value={1}>Женский</Radio>
                            </Radio.Group>
                            {(genderDirty && genderError) && <p className="error-alert">{genderError}</p>}
                        </div>
                        <h2 style={{ marginBottom: '20px' }}> Место жительства </h2>
                        <Form>
                            <Form.Group className="form-group" controlId="formArea">
                                <Form.Label> Область </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='area'
                                    value={region} 
                                    onBlur={blurHandler} 
                                    onChange={regionHandler}
                                    isInvalid={!!(regionDirty && regionError)} 
                                />
                                {(regionDirty && regionError) && <p className="error-alert">{regionError}</p>}
                            </Form.Group>
                            <Form.Group className="form-group" controlId="formCity">
                                <Form.Label> Город </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='city'
                                    value={city} 
                                    onBlur={blurHandler} 
                                    onChange={cityHandler}
                                    isInvalid={!!(cityDirty && cityError)} 
                                />
                                {(cityDirty && cityError) && <p className="error-alert">{cityError}</p>}
                            </Form.Group>
                            <br />
                            {error && <ErrorMessage message={error} />}
                            <Button type="primary" onClick={handleContinue}> Продолжить </Button>
                            <Button type="text" onClick={() => navigate("/fillProfile2")}> Пропустить </Button>
                        </Form>
                    </div>
                </div>
            </div>
            <Styles>
                <div className="progress"></div>
            </Styles>
        </>
    );
};